'use client';

import './globals.css';
import { Heading, Button } from '@/components/ui'

import { useEffect } from 'react';
import * as Sentry from '@sentry/nextjs';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <html lang="en"><body>
    <div className="flex min-h-screen items-center justify-center bg-canvas px-4">
      <div className="w-full max-w-md rounded-lg bg-surface p-8 shadow-lg">
        <Heading level={2} className="mb-4 text-ink-strong">
          Critical Error
        </Heading>
        <p className="mb-6 text-sm text-muted">
          A critical error occurred. Please refresh the page.
        </p>
        <Button variant="primary"
          onClick={reset}
          className="w-full text-on-accent"
        >
          Refresh Page
        </Button>
      </div>
    </div>
    </body></html>
  );
}